<template>
    <div class="pay-finished-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="pay-goods-content mask-content">
            <span class="close-icon" @click="isShow = false"></span>
            <div class="pay-title">温馨提示</div>
            <div class="content">支付成功，请下载安装客户端。</div>
            <div class="install-bt" @click="downloadClick">安装客户端</div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'PayFinished',
    data() {
        return {
            isShow: false,
            payStatus: ''
        }
    },
    computed: {
        ...mapState(['payAgreement', 'landpageDl', 'indexDl'])
    },
    watch: {
        isShow: function (value) {
            if (value) {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('pay-finished-page')
                })
            } else {
                this.payStatus = ''
                this.$Utils.loopQueryVipInfo()
            }
        }
    },
    methods: {
        show() {
            this.isShow = true
        },
        downloadClick() {
            this.dlClient()
        },

        dlClient(payload) {
            let dlLink = this.landpageDl || this.indexDl

            if (this.$route.path == '/detail') {
                if (this.landpageDl) {
                    try {
                        const dlQuery = this.$Utils.getUrlParams(this.landpageDl)
                        const goods_id = this.$route.query.goods_id
                        if (this.validateFilename(dlQuery.n) && goods_id > 0) {
                            let joinNstr = '',
                                targetDl = ''
                            const dlArr = this.landpageDl.split('?')
                            const splitArr = dlQuery.n.split('_')
                            splitArr[splitArr.length - 1] = `${this.$route.query.goods_id}.exe`
                            joinNstr = splitArr.join('_')
                            targetDl = `${dlArr[0]}?n=${joinNstr}`
                            dlLink = targetDl
                        }
                    } catch (error) {}
                }
            }
            // 详情页底部"开始游戏"按钮
            if (payload !== 'start-btn') {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 2 })
            }
            window.open(dlLink, '_self')
        }
    }
}
</script>

<style lang="less" scoped>
.pay-finished-page {
    .pay-goods-content {
        position: fixed;
        width: 500px;
        height: 310px;
        background: linear-gradient(180deg, #fdf7ea, #ffffff);
        border-radius: 10px;

        .close-icon {
            width: 15px;
            height: 16px;
            background: url(../../../assets/dialog/close.png) center/100% no-repeat;

            &:hover {
                background: url(../../../assets/dialog/close-hover.png) center/100% no-repeat;
            }
        }

        .pay-title {
            margin-top: 60px;
            font-size: 20px;
            color: #8e5126;
            font-weight: bold;
            text-align: center;
        }

        .content {
            font-size: 16px;
            color: #333;
            text-align: center;
            margin: 40px;
        }
        .install-bt {
            margin: 48px auto 0;
            width: 180px;
            height: 43px;
            line-height: 43px;
            text-align: center;
            color: #fff;
            font-size: 16px;
            background: linear-gradient(0deg, #f54b41, #f56b43);
            border-radius: 22px;
            &:hover {
                cursor: pointer;
                background: #f45b4b;
            }
        }
    }
}
</style>
